import { Expose, Type } from "class-transformer";
import { Model } from "./model";
import { Category } from "./category-model";
import { LanguageEnum } from "../../common";
import { BaseTeacher } from "./base-teacher-model";

export class BaseReport extends Model {
  @Expose({name : "categorize"})
  @Type(()=>Category)
  categories : Category[];

  @Expose() id : string ;
}

